import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { translateSubElementString } from "../../../../../../../utils";
import CategoryPreviewWrapper from "./CategoryPreviewWrapper";
import { DataTable } from "../../../../../../../components/DataTable";
import { Flex, Text } from "@chakra-ui/react";
import { NumberField } from "../../../../../../../components/NumberField";

function UseOfSoldProductsPreview({ currentElement: { items, totalCo2Emissions }}) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.useOfSoldProducts"
  });

  const columns = useMemo(
    () => [
      {
        header: t("itemBrand"),
        accessorKey: "itemBrand",
        size: 100
      },
      {
        header: t("itemDescription"),
        accessorKey: "itemDescription",
        size: 200
      },
      {
        header: t("numberOfItemsSold"),
        accessorKey: "numberOfItemsSold",
        size: 150
      },
      {
        header: translateSubElementString("reportsPage.scopeThree.inputs.useOfSoldProducts.emissions"),
        accessorKey: "totalEmission",
        size: 100
      }
    ],
    [t]
  );

  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={totalCo2Emissions} marginStart="2" />
      </Flex>
      <DataTable
        data={items ?? []}
        columns={columns}
        containerHeight={items && items.length > 0 ? "370px" : null}
      />
    </CategoryPreviewWrapper>
  );
}

export default UseOfSoldProductsPreview;